import React from 'react';

type TwoLabelToggleProps = {
  checked: boolean;
  onChange: (nextValue: boolean) => void;
  leftLabel: string;
  rightLabel: string;
  className?: string;
  disabled?: boolean;
};

const TwoLabelToggle: React.FC<TwoLabelToggleProps> = ({ checked, onChange, leftLabel, rightLabel, className = '', disabled = false }) => {
  return (
    <label
      className={`flex items-center relative ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} ${className}`}
      aria-disabled={disabled}
    >
      <input
        type="checkbox"
        className="sr-only"
        checked={checked}
        disabled={disabled}
        onChange={() => {
          if (!disabled) {
            onChange(!checked);
          }
        }}
      />

      <span className="mr-3 text-base font-medium" style={{ color: checked ? '#9CA3AF' : '#FFFFFF', fontWeight: checked ? 400 : 500 }}>
        {leftLabel}
      </span>

      <div className="w-14 h-7 rounded-full bg-red-700 relative transition-all duration-300 ease-in-out">
        <div
          className={`absolute top-[3px] left-[3px] w-[22px] h-[22px] bg-white rounded-full shadow-md transition-transform duration-300 ease-in-out ${
            checked ? 'translate-x-[28px]' : 'translate-x-0'
          }`}
        />
      </div>

      <span className="ml-3 text-base font-medium" style={{ color: checked ? '#FFFFFF' : '#9CA3AF', fontWeight: checked ? 500 : 400 }}>
        {rightLabel}
      </span>
    </label>
  );
};

export default TwoLabelToggle;
